import { render, staticRenderFns } from "./council.vue?vue&type=template&id=cc5eb3c0&scoped=true"
import script from "./council.vue?vue&type=script&lang=js"
export * from "./council.vue?vue&type=script&lang=js"
import style0 from "./council.vue?vue&type=style&index=0&id=cc5eb3c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc5eb3c0",
  null
  
)

export default component.exports